import _ from "lodash";
import { BONGA_FPSO_ID, ERHA_FPSO_ID, USAN_FPSO_ID } from "../utils/ids";

export const ERHA_MODULES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'Hull Deck', 'Helideck', 'AD-HOC'];
export const USAN_MODULES = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6',  'P7', 'P8', 'P9', 'S1', 'S2', 'S3','S4', 'S5', 'S6', 'S7', 'S8', 'S9', 'R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9', 'R1-R9', 'ACCOMODATION', 'AD-HOC'];
export const BONGA_MODULES = [
    'FGC Level 1',
    'FGC Level 2',
    'FGC Level 3',
    'Flare Scrubber Area',
    'LACT Level 1',
    'LACT Level 2',
    'LACT Level 3',
    'Main Deck Laydown Forward',
    'Main deck under Aft Laydown',
    'Main deck under Compressor Control',
    'Main deck under Flare Scrubber',
    'Main deck under Forward Laydown Area',
    'Main deck under LACT',
    'Main deck under Port Process',
    'Main deck under Port Subsea',
    'Main deck under Power',
    'Main deck under Sales Gas',
    'Main deck under Starboard Process',
    'Port Process Level 1',
    'Port Subsea Mezz Level',
    'Power Module Level 1',
    'Power Module Level 2',
    'Power Module Level 3',
    'Sales Gas Module',
    'Starboard Process Level 1',
    'Starboard Process Level 2',
    'Starboard Subsea Level 1',
    'Starboard Subsea Level 2',
    'Starboard Subsea Main deck',
    'Starboard Subsea Mezz Level',
    'VRU Level 1',
    'VRU Level 2',
    'VRU Level 3',
    'Waterflood Level 1',
    'Waterflood Level 2',
    'Waterflood Level 3',
    'Port Process Level 2',
    'Port Process Mezz Level',
    'Port Subsea Level 1',
    'Heli Deck',
    'Accommodation',
];

export const PREFIXABLE_MODULES = _.difference([...ERHA_MODULES, ...USAN_MODULES], ['ACCOMODATION', 'AD-HOC', 'Hull Deck', 'Helideck'])

export const MODULE_MAPPINGS = {
    [ERHA_FPSO_ID]: ERHA_MODULES,
    [USAN_FPSO_ID]: USAN_MODULES,
    [BONGA_FPSO_ID]: BONGA_MODULES,
};

